// extracted by mini-css-extract-plugin
module.exports = {"back-button-link":"shared-BackButton-back-button-link-f31cb284","backButtonLink":"shared-BackButton-back-button-link-f31cb284"};